/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_TitleInputs */

const vi_einvoice_manual_title = /** @type {(inputs: Einvoice_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất trên MISA`)
};

/**

* @param {Einvoice_Manual_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_title = /** @type {((inputs?: Einvoice_Manual_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_title(inputs)
});